import app from 'flarum/common/app';

app.initializers.add('vendor/jeepyta-options', () => {
  // console.log('[vendor/jeepyta-options] Hello, forum and admin!');
});
